var _rect, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#ECF9EE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0214 11.9617L18.2916 8.19181C18.2045 8.10378 18.0853 8.05336 17.9608 8.0527L11.3984 8.01769C10.623 8.01356 9.98882 8.64103 9.98469 9.41642L9.91435 22.6037C9.91021 23.3791 10.5377 24.0133 11.3131 24.0175L20.6879 24.0675C21.4633 24.0716 22.0975 23.4441 22.1017 22.6687L22.157 12.2939C22.1577 12.1661 22.1047 12.0458 22.0214 11.9617ZM18.421 9.65558L20.5591 11.8166L18.8783 11.8076C18.6198 11.8063 18.4107 11.5949 18.4121 11.3364L18.421 9.65558ZM20.6929 23.13L11.3181 23.08C11.0596 23.0786 10.8505 22.8672 10.8518 22.6087L10.9222 9.42142C10.9236 9.16296 11.135 8.9538 11.3934 8.95518L17.4871 8.98768L17.4746 11.3314C17.4704 12.1068 18.0979 12.741 18.8733 12.7451L21.217 12.7576L21.1642 22.6637C21.1628 22.9222 20.9514 23.1314 20.6929 23.13Z",
    fill: "#46C35F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8632 14.6825L13.2383 14.6525C12.9794 14.6511 12.7684 14.8599 12.767 15.1188C12.7657 15.3776 12.9744 15.5886 13.2333 15.59L18.8582 15.62C19.1171 15.6214 19.3281 15.4126 19.3294 15.1538C19.3308 14.8949 19.1221 14.6839 18.8632 14.6825Z",
    fill: "#46C35F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8534 16.5575L13.2285 16.5275C12.9696 16.5261 12.7586 16.7349 12.7573 16.9938C12.7559 17.2526 12.9646 17.4636 13.2235 17.465L18.8484 17.495C19.1073 17.4964 19.3183 17.2876 19.3197 17.0288C19.3211 16.7699 19.1123 16.5589 18.8534 16.5575Z",
    fill: "#46C35F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8427 18.4326L13.2178 18.4026C12.9589 18.4012 12.7479 18.61 12.7465 18.8688C12.7451 19.1277 12.9539 19.3387 13.2128 19.3401L18.8377 19.3701C19.0966 19.3715 19.3075 19.1627 19.3089 18.9038C19.3103 18.645 19.1016 18.434 18.8427 18.4326Z",
    fill: "#46C35F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9579 20.2976L13.208 20.2776C12.9491 20.2762 12.7381 20.485 12.7368 20.7438C12.7354 21.0027 12.9441 21.2137 13.203 21.2151L16.9529 21.2351C17.2118 21.2365 17.4228 21.0277 17.4242 20.7688C17.4256 20.51 17.2168 20.299 16.9579 20.2976Z",
    fill: "#46C35F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8.08594 8) rotate(0.305596)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.4e3700e0b1b959028c7a816988810fa5.svg";
export { ForwardRef as ReactComponent };